import { Col, Row } from 'reactstrap';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentUser, getUserPaymentDetails } from 'redux/query';

export const SubscriptionDetailProductName = () => {
  const { subscriptions = [] } = useSelector(getCurrentUser);
  const { product } = useSelector(getUserPaymentDetails);

  const productName = useMemo(() => {
    return product || 'keine Freischaltung vorhanden';
  }, [subscriptions, product]);

  return (
    <Row className="mt-2">
      <Col xs={12} sm={6} className="subscription-status-title">
        <strong>Freischaltung</strong>
      </Col>
      <Col xs={12} sm={6}>
        {productName}
      </Col>
    </Row>
  );
};
